import './FlashcardForm.css'; // Import the CSS file

import React, { useState, useEffect } from 'react';
import { getLatestFlashcardId, saveFlashcardData } from '../../../../services/DashboardApi';

import { FaArrowLeft } from 'react-icons/fa';
import { logger } from '../../../../utils/logger';
import useIsMobile from '../../../../hooks/ismobile';
import { logUserActivity } from '../../../../services/UsersApi';
const FlashcardForm = ({
	boxId,
	topicId,
	subtopicId,
	userId,
	notebookId,
	subject,
	subtopicName,
	topicName,
	flashcardFormData,
	setIsAIGeneratedSaved,
	flashcards,
	setFlashcards,
	setShowFlashcardForm,
	setShowCreateOptions,
}) => {
	const [aiGeneratedFlashcards, setAIGeneratedFlashcards] = useState(
		flashcardFormData.map((card) => ({
			question: card.question || card.Question || '',
			answer: card.answer || card.Answer || '',
			selected: false,
		}))
	);
	//const [flashcards, setFlashcards] = useState(flashcardFormData);
	const [selectAll, setSelectAll] = useState(false);
	const [startTime, setStartTime] = useState(null);

	useEffect(() => {
		setStartTime(new Date().toISOString());
	}, []);

	const handleInputChange = (index, field, value) => {
		const updatedFlashcards = [...aiGeneratedFlashcards];
		updatedFlashcards[index][field] = value;
		setAIGeneratedFlashcards(updatedFlashcards);
		logger.log('3 Flashcards:', flashcards);
	};

	const handleCheckboxChange = (index) => {
		const updatedFlashcards = [...aiGeneratedFlashcards];
		updatedFlashcards[index].selected = !updatedFlashcards[index].selected;
		setAIGeneratedFlashcards(updatedFlashcards);

		// Check if all checkboxes are selected
		const allSelected = updatedFlashcards.every((card) => card.selected);
		setSelectAll(allSelected);
	};

	const handleSelectAllChange = () => {
		const newSelectAll = !selectAll;
		setSelectAll(newSelectAll);
		const updatedFlashcards = aiGeneratedFlashcards.map((card) => ({
			...card,
			selected: newSelectAll,
		}));
		setAIGeneratedFlashcards(updatedFlashcards);
		logger.log('5 Flashcards:', flashcards);
	};

	const handleSave = async () => {
		let selectedFlashcards = aiGeneratedFlashcards.filter((card) => card.selected);
		if (selectedFlashcards.length === 0) {
			alert('Please select at least one flashcard to save.');
			return;
		} else {
			let flashcardData = selectedFlashcards.map((card) => ({
				question: card.question,
				answer: card.answer,
				type: 'AI Generated',
			}));

			const finalFlashcards = selectedFlashcards.map((card) => {
				return {
					content: {
						front: card.question,
						back: card.answer,
						type: 'AI Generated',
					},
				};
			});

			logger.log('flashcardData: ', flashcardData);
			logger.log('finalFlashcards: ', finalFlashcards);
			const latestIdResponse = await getLatestFlashcardId();
			const id = latestIdResponse.data.latestId;
			const newEntry = {
				FLASHCARD_ID: id.toString(),
				BOX_ID: boxId,
				FLASHCARDS_CONTENT: flashcardData,
				NOTEBOOK_ID: String(notebookId),
				SUBJECT: subject,
				SUBTOPIC_ID: subtopicId,
				SUBTOPIC_NAME: subtopicName,
				TOPIC_ID: topicId,
				TOPIC_NAME: topicName,
				USER_ID: userId,
			};
			logger.log('1. New Entry of flashcard:', newEntry);
			await saveFlashcardData(newEntry);
			setIsAIGeneratedSaved(true);
			setShowFlashcardForm(false);
			setFlashcards((prevFlashcards) => [...prevFlashcards, ...finalFlashcards]);
			logger.log('6 Flashcards:', flashcards);
			const endTime = new Date().toISOString();
			const durationSec = Math.round((new Date(endTime) - new Date(startTime)) / 1000);

			await logUserActivity({
				userId,
				eventType: 'KC_AI_GENERATED_FLASHCARD',
				startTime: startTime,
				endTime: endTime,
				durationSec,
				topicId,
				subtopicId,
				// notebookId,
			});
		}
	};

	const handleBackClick = () => {
		setShowCreateOptions(true);
		//setAICreated(false);
		setShowFlashcardForm(false);
		//setPendingPrompt(null);
		//setSelectedFiles([]);
	};

	return (
		<React.Fragment>
			<div
				style={{
					width: '100%',
					textAlign: 'left',
					padding: '10px',
					marginLeft: '20%',
					marginTop: '2%',
				}}
			>
				<FaArrowLeft className="back-icon" onClick={handleBackClick} />
			</div>
			<div className="flashcard-form-container">
				<table className="flashcard-table">
					<thead>
						<tr>
							<th>Term</th>
							<th>Definition</th>
							<th className="checkbox-cell">
								<input
									type="checkbox"
									checked={selectAll}
									onChange={handleSelectAllChange}
								/>
								{!useIsMobile && 'Select All'}
							</th>
						</tr>
					</thead>
					<tbody>
						{aiGeneratedFlashcards.map((card, index) => (
							<tr key={index}>
								<td>
									<input
										type="text"
										value={card.question}
										onChange={(e) =>
											handleInputChange(index, 'term', e.target.value)
										}
										className="input-field"
									/>
								</td>
								<td>
									<input
										type="text"
										value={card.answer}
										onChange={(e) =>
											handleInputChange(index, 'definition', e.target.value)
										}
										className="input-field"
									/>
								</td>
								<td className="checkbox-cell">
									<input
										type="checkbox"
										checked={card.selected}
										onChange={() => handleCheckboxChange(index)}
									/>
								</td>
							</tr>
						))}
					</tbody>
				</table>
				<button className="save-button" onClick={handleSave}>
					Save
				</button>
			</div>
		</React.Fragment>
	);
};

export default FlashcardForm;
